module.exports = __webpack_public_path__ + "media/components/breakheader/background/background--5-cc4e0338ce724fb114e378bb43111a88.jpg";